import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'
import HomeView from '../views/home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/location',
    name: 'location',
    component: () => import(/* webpackChunkName: "about" */ '../views/location.vue')
  },
  {
    path: '/facilities',
    name: 'facilities',
    component: () => import(/* webpackChunkName: "about" */ '../views/facilities.vue')
  },
  {
    path: '/interior',
    name: 'INTERIOR',
    component: () => import(/* webpackChunkName: "about" */ '../views/interior.vue')
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: () => import(/* webpackChunkName: "about" */ '../views/gallery.vue')
  },
  {
    path: '/Eligibility-Booklet',
    name: 'Eligibility-Booklet',
    component: () => import(/* webpackChunkName: "about" */ '../views/bligibilityBooklet.vue')
  },
  {
    path: '/developers',
    name: 'developers',
    component: () => import(/* webpackChunkName: "about" */ '../views/developers.vue')
  },
  {
    path: '/developers',
    name: 'developers',
    component: () => import(/* webpackChunkName: "about" */ '../views/developers.vue')
  },
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes
})

export default router
